const t = "ids-popover-v5150", o = "ids-popover--portal-v5150", p = "ids-popover--has-input-activator-v5150", a = "ids-popover--input-activator-portal-v5150", r = "ids-popover--content-v5150", v = "ids-popover--activator-v5150", s = {
  popover: t,
  portal: o,
  hasInputActivator: p,
  inputActivatorPortal: a,
  content: r,
  activator: v
};
export {
  s
};
